export const RAYALDEE_QR_URL =
  'https://conference.rayaldee.com/?utm_source=ckd+shpt+quiz&utm_medium=app&utm_campaign=conference+support&utm_content=conference+qr'
